import React from 'react';
import Comps from '@owenscorning/react-library';
import { useDispatch, useSelector } from 'react-redux';

import BackButton from '../../shared/BackButton';
import CTAButton from '../../../CTAButton';
import { incrementStep, setFormData, backToStep3 } from '../redux/action';
import { EMAIL_REGEX } from '../../shared/utils';

const TextInput = Comps.Connect.FormElements.Text;

const Step4 = () => {
  const dispatch = useDispatch();
  const formData = useSelector(state => state.formData);

  return (
    <div>
      <BackButton
        analytics={{
          "data-track": "form-back",
          "data-track-form-name": "Submit Claim",
          "data-track-form-step": "step 4 - contact information"
        }}
        onClick={() => dispatch(backToStep3())}
        backText={'Warranty Coverage'}
      />
      <p>
        Before we can initiate your claim, we need to make sure we have a good
        way to get in touch with you.
      </p>

      <div className="txtContainer">
        <h4>Contact Information</h4>
        <div className="mb20">
          <TextInput
            name="contactEmail"
            value={formData.contactInfo.email || ''}
            htmlAttributes={{
              placeholder: 'Email',
            }}
            onChange={email => {
              dispatch(
                setFormData({
                  contactInfo: {
                    ...formData.contactInfo,
                    email,
                    preferredContactMethods: 'email',
                  },
                })
              );
            }}
          />
        </div>
        <div className="mb10">
          <TextInput
            name="contactPhone"
            value={formData.contactInfo.phone || ''}
            htmlAttributes={{
              placeholder: 'Phone',
              pattern: '[0-9 -]*',
              isPhoneInput: 'true',
              maxLength: 12,
            }}
            onChange={phone => {
              dispatch(
                setFormData({
                  contactInfo: {
                    ...formData.contactInfo,
                    phone,
                  },
                })
              );
            }}
          />
        </div>
      </div>

      <CTAButton
        onClick={() => dispatch(incrementStep())}
        data-track="form-advance"
        data-track-form-name="Submit Claim"
        data-track-form-step="step 4 - contact information"
        element="button"
        text="Next"
        type="submit"
        disabled={
          !(
            formData.contactInfo.phone &&
            formData.contactInfo.phone.length === 12 &&
            formData.contactInfo.email &&
            EMAIL_REGEX.test(formData.contactInfo.email)
          )
        }
      />
    </div>
  );
};

export default Step4;
